export default {"src":"/_next/static/media/KTM.09801c32.svg","height":300,"width":964,"blurWidth":0,"blurHeight":0};